/**
 * Created by litao on 2018/10/8.
 */

export default (http) => {
    return {
        queryElectricPage(data) {
            return http.json({
                url: `/erp/warranty/card/queryElectricRecord?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        queryPcElectricRecord(data) {
            return http.json({
                url: `/erp/warranty/card/queryPcElectricRecord?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        queryCarOwnerPage(data) {
            return http.json({
                url: `/erp/warranty/card/queryCarOwnerPage?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },
        getInfo(data) {
            return http.json({
                url: `/erp/warranty/card/get?id=${data.id}`,
                data
            })
        },
        getOne(data) {
            return http.json({
                url: `/erp/warranty/card/getOne`,
                data
            })
        },
        /**
         * 查询质保信息
         * @param data
         * @return {*}
         */
        count(data) {
            return http.json({
                url: `/erp/warranty/card/count`,
                data
            })
        },

        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryByPage(data) {
            return http.json({
                url: `/erp/warranty/card/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        queryAll(data) {
            return http.json({
                url: `/erp/warranty/card/queryAll`,
                data
            })
        },

        queryByUserId(data) {
            return http.json({
                url: `/erp/warranty/card/queryByUserId`,
                data
            })
        },


        queryAllWarrantyBySn(data) {
            return http.json({
                url: `/erp/warranty/card/queryAllWarrantyBySn`,
                data
            })
        },

        queryAllWarrantyByMobile(data) {
            return http.json({
                url: `/erp/warranty/card/queryAllWarrantyByMobile`,
                data
            })
        },


        saveAccountAndWarrantyCard(data) {
            return http.json({
                url: `/erp/warranty/card/saveAccountAndWarrantyCard`,
                data
            })
        },



        pass(data) {
            return http.json({
                url: `/erp/warranty/card/pass`,
                data
            })
        },

        fail(data) {
            return http.json({
                url: `/erp/warranty/card/fail`,
                data
            })
        },


    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/warrantyCard.js